/**
 * Build the phase payload shape expected by InteriorDesignerPhaseDetails from /projects/phase rows.
 */
export function buildPhaseDataItemFromProjectPhase(phaseRow, projectData) {
  if (phaseRow?.projectPhase) {
    return phaseRow;
  }
  return {
    projectPhase: {
      ...phaseRow,
      project: projectData,
    },
    buildings: phaseRow.buildings || [],
    configs:
      phaseRow.configurations ||
      phaseRow.configs ||
      phaseRow.propertyConfigurations ||
      [],
    completionPercentage: phaseRow.completionPercentage ?? 0,
    subscriptionFee: phaseRow.subscriptionFee ?? 0,
  };
}
